__turbopack_context__.v({
  "header": "styles-module__WwhwyW__header",
  "logo": "styles-module__WwhwyW__logo",
});
